﻿import { createFileRoute } from "@tanstack/react-router";
import { RelatorioMovimentacaoPage } from "@/paginas/pg_franquia/franquia-estoque-relatorios-movimentacao";

export const Route = createFileRoute("/_authenticated/franquia-estoque-relatorios-movimentacao")({
  head: () => ({
    meta: [
      { title: "Relatórios de movimentação — Milky Moo Palmares" },
      {
        name: "description",
        content: "Gere relatórios de movimentação de estoque com filtros e exportação.",
      },
      { property: "og:title", content: "Relatórios de movimentação — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Gere relatórios de movimentação de estoque com filtros e exportação.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: RelatorioMovimentacaoPage,
});
